class LoadMoreInsight {
	constructor() {
		if (document.querySelector(".insights-grid__load-more a")) {
			document
				.querySelector(".insights-grid__load-more a")
				.addEventListener("click", (e) => {
					e = e || window.event;
					if (e.preventDefault) {
						e.preventDefault();
					}
					if (e.stopPropagation) {
						e.stopPropagation();
					}

					let xmlhttp = window.ajaxReq();
					xmlhttp.open("GET", e.target.href, true);
					xmlhttp.send();
					xmlhttp.onreadystatechange = () => {
						if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
							try {
								let page = xmlhttp.responseText;
								let parser = new DOMParser();
								let doc = parser.parseFromString(page, "text/html");

								// Append data
								document.querySelector("#insights-grid").innerHTML =
									doc.querySelector("#insights-grid").innerHTML;

								window.modulesLoader.loadModules();
							} catch (error) {}
						}
					};
					return false;
				});
		}
	}
}

export default LoadMoreInsight;
